import React from 'react';

const Step8Infos = (props) => {
    return (
        <div className="slc-wizard-infos-step slc-wizard-infos-step-8">
        Questa informazione ci permette di valutare le caratteristiche dei tuoi consumi.
        </div>
    );
}

export default Step8Infos;